
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { PotentialMatch } from "@/types/candidate";
import { BarChart2 } from "lucide-react";
import { Link } from "react-router-dom";

interface CandidatePotentialMatchesProps {
  matches: PotentialMatch[];
  isLoading?: boolean;
}

export const CandidatePotentialMatches: React.FC<CandidatePotentialMatchesProps> = ({ 
  matches,
  isLoading = false
}) => {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-digger-blue mx-auto mb-4"></div>
            <p className="text-gray-500">Finding potential job matches...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  // Filter out matches that don't have a jobId
  const filteredMatches = matches.filter(match => match.jobId);

  if (!filteredMatches || filteredMatches.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center py-8">
            <BarChart2 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-700 mb-2">No potential matches</h3>
            <p className="text-gray-500">No job matches have been found for this candidate yet.</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4">Potential Job Matches</h3>
        <div className="space-y-4">
          {filteredMatches.map((match, index) => (
            <div key={index} className="border rounded-md p-4">
              <div className="flex justify-between items-center">
                <div>
                  <Link to={`/jobs/${match.jobId}`} className="font-medium text-digger-blue hover:underline">
                    {match.position}
                  </Link>
                  <p className="text-sm text-gray-600">{match.companyName}</p>
                </div>
                <div className="bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded">
                  {match.match}% Match
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
